<template>
    <div id="mental-health-survey-review" class="row">
        <div class="col-12 col-lg-6">
            <h1>Here's what you've told us.</h1>
            <div>
                <div v-for="answer of report" 
                    :key="answer.slug"
                >
                    <template v-if="!slugs || slugs.includes(answer.slug)">
                        <label>{{answer.question_text}}</label>
                        <label v-if="answer.free_text">
                            {{ answer.answer.length > 100 ? `${answer.answer.substring(0, 100)}...` : answer.answer }}
                        </label>
                        <div v-else-if="answer.star_rating">
                            <div v-for="i of answer.star_rating.max_stars" :key="i">
                                {{ star_template(i, answer.answer) }}
                            </div>
                        </div>
                        <div v-else-if="answer.multiple_choice">
                            <ul class="pills" >
                                <template v-for="option of answer.multiple_choice.options" >
                                    <li :key="option.id" 
                                        v-if="answer.answer.selections.includes(option.id)" 
                                    >
                                        {{ option.display_label }}
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>
            <div class='footer row'>
                <button class="btn" @click="reset" >
                    Back to start
                </button>
                <button class="btn btn-primary" @click="submit" >
                    Submit
                </button>
            </div>
        </div>
            
        <div class="col-6 d-none d-lg-block">
            <div class="vertical-align-md">
                <img
                    src="@/assets/img/results-img@2x.png"
                    alt="BetterMynd"
                    class="side-img"
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        survey: {
            type: Object,
            required: true
        },
        responses: {
            type: Object,
            required: true
        },
        slugs: {
            type: Array,
            required: false,
        }
    },
    computed: {
        report() {
            return this.survey.questions.map(question => ({ ...question, answer: this.responses[question.slug] }))
        }
    },
    methods: {
        star_template(i, answer){
            return i <= answer  
                ? "★" 
                : "☆"
        },
        reset() {
            this.$emit('reset')
        },
        submit() {
            this.$emit('submit')
        }
    }
}
</script>

<style lang="scss" scoped>
#mental-health-survey-review {
  .inner-card {
    @include border-radius($border-radius);

    border: solid 1px white;
    padding: 30px;
  }

  .footer {
    justify-content: right;

    .btn {
      margin-right: 5px;
      margin-bottom: 5px;

      @media (min-width: $lg-min) {
          min-width: 120px;
      }

      @media (min-width: $md-min) {
          min-width: 120px;
      }
    }

    .btn:not(.btn-primary) {
      background-color: $dark-blue;
      border-color: $green;
      color: $green;
    }
  }

  .side-img {
    max-width: 100%;
  }
}
</style>